// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-container[data-v-7020700e] {\n  padding: 24px;\n}\n.loadingBox[data-v-7020700e] {\n  display: flex;\n  flex-direction: column;\n  padding-top: 200px;\n  justify-content: center;\n  align-items: center;\n}\n.loadingBox span[data-v-7020700e] {\n  margin-top: 30px;\n  font-size: 24px;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
